import { Injectable } from '@angular/core';

import { NotificationTypeEnum } from '../../../../shared/enums';
import { ClipboardService, NotificationService } from '../../../../shared/services';
import { LandingPaths } from '../../../../shared/enums/routerPaths.enum';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  constructor(
    private clipboard: ClipboardService,
    private notificationService: NotificationService,
  ) {}

  copyInviteUrl(hash: string): void {
    if (hash) {
      const inviteUrlWithoutHash: string = UserProfileService.getInviteUrlWithoutHash();
      const inviteUrl = `${inviteUrlWithoutHash}${hash}`;

      this.clipboard.copy(inviteUrl);
      this.notificationService.notify(
        NotificationTypeEnum.SUCCESS,
        'NOTIFICATION.INVITATION_SUCCESSFULLY_COPED',
      );
    }
  }

  private static getInviteUrlWithoutHash(): string {
    const urlBase: string = location?.origin;

    return urlBase ? `${urlBase}${LandingPaths.INVITE}` : '';
  }
}
